import { HighlightType } from '../types/profile';
import { getHighlightIdentity } from './highlightIdentity';

export function getHighlightIdentifier(
    highlight?: HighlightType | null
): string | null {
    if (!highlight) return null;
    return getHighlightIdentity(highlight);
}

export function getModalNavigableHighlights(
    highlights: HighlightType[]
): HighlightType[] {
    const firstJamBoardIndex = highlights.findIndex(
        (item) => item?.isVirtualJamBoardHighlight
    );
    if (firstJamBoardIndex === -1) {
        return highlights;
    }
    return highlights.filter(
        (item, index) =>
            !item?.isVirtualJamBoardHighlight || index === firstJamBoardIndex
    );
}

export function getModalCurrentIndex(
    navigableHighlights: HighlightType[],
    selectedHighlight?: HighlightType | null
): number {
    if (!navigableHighlights.length) return 0;
    if (selectedHighlight?.isVirtualJamBoardHighlight) {
        const firstJamBoardIndex = navigableHighlights.findIndex(
            (item) => item?.isVirtualJamBoardHighlight
        );
        return firstJamBoardIndex >= 0 ? firstJamBoardIndex : 0;
    }
    const selectedId = getHighlightIdentifier(selectedHighlight);
    const index = navigableHighlights.findIndex(
        (item) => getHighlightIdentifier(item) === selectedId
    );
    return index >= 0 ? index : 0;
}
